<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <b-tabs>
      <b-tab title="Sistemas"><fcc-sistema @carregado="carregado.tipoSistema = true" /></b-tab>
      <b-tab title="Situações"><fcc-situacao @carregado="carregado.situacao = true" /></b-tab>
      <b-tab title="Equipes"><fcc-equipes @carregado="carregado.equipes = true" /></b-tab>
      <b-tab title="Responsáveis"
        ><fcc-responsavel @carregado="carregado.responsavel = true" />
      </b-tab>
      <b-tab title="Níveis de dificuldade"
        ><fcc-dificuldade @carregado="carregado.dificuldade = true" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import fccEquipes from './fccEquipes.vue'
import fccDificuldade from './fccDificuldade.vue'
import fccResponsavel from './fccResponsavel.vue'
import fccSituacao from './fccSituacao.vue'
import fccSistema from './fccSistema.vue'
export default {
  components: { fccSistema, fccSituacao, fccEquipes, fccResponsavel, fccDificuldade },
  data() {
    return {
      titlePage: 'Configurações',
      carregado: {
        tipoSistema: false,
        situacao: false,
        equipes: false,
        responsavel: false,
        dificuldade: false
      }
    }
  },
  watch: {
    carregado: {
      handler(value) {
        if (
          value.tipoSistema &&
          value.situacao &&
          value.equipes &&
          value.responsavel &&
          value.dificuldade
        )
          this.carregaTexto()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.carregaTexto(this.codeMensagem('C01'))
  }
}
</script>